// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function WifiSlashIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M26.74 26.328a.999.999 0 0 1-.786 1.68 1.001 1.001 0 0 1-.694-.335l-6.5-7.144a7.5 7.5 0 0 0-7.176.905.998.998 0 0 1-1.576-.568 1 1 0 0 1 .398-1.049A9.429 9.429 0 0 1 16 18c.16 0 .319 0 .477.012l-3.364-3.7c-2.004.439-3.88 1.329-5.488 2.602a1 1 0 0 1-1.409-.164 1 1 0 0 1 .159-1.404 15.535 15.535 0 0 1 5.214-2.707L8.67 9.425a19.427 19.427 0 0 0-5.036 3 1.002 1.002 0 0 1-1.27-1.55A21.484 21.484 0 0 1 7.25 7.857L5.26 5.672a1 1 0 1 1 1.48-1.345l20 22ZM16 24a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm13.635-13.125a21.537 21.537 0 0 0-16.385-4.7 1 1 0 1 0 .25 1.984 19.532 19.532 0 0 1 14.865 4.262 1 1 0 1 0 1.27-1.546Zm-5.26 6.039a1 1 0 1 0 1.242-1.568 15.532 15.532 0 0 0-6.466-3.025 1.002 1.002 0 0 0-1.052 1.536.998.998 0 0 0 .651.423c2.054.43 3.98 1.331 5.625 2.634Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
